import React from 'react'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import ParticipantAndDetails from './ParticipantAndDetails'
import { useApproveCheckInRequest } from 'api/Event/Attendance'
import { CheckinOutAttendeeWithType } from 'types/event/eventAttendance'
import ButtonSpinner from 'components/global/ButtonSpinner'

const ApproveCheckIn = () => {
  const {
    participantData,
    setCheckInOutModal,
    setApproveCheckInModal,
  }: {
    participantData: CheckinOutAttendeeWithType
    setCheckInOutModal: (state: boolean) => void
    setApproveCheckInModal: (state: boolean) => void
  } = eventAttendanceStore(store => ({
    participantData: store.participantData,
    setCheckInOutModal: store.setCheckInOutModalOpen,
    setApproveCheckInModal: store.setApproveCheckInModal,
  }))

  const {
    mutate: approveCheckInRequestMutation,
    isLoading: approveCheckInRequestLoading,
  } = useApproveCheckInRequest()

  const handleApproveCheckin = () => {
    approveCheckInRequestMutation(
      { checkInId: participantData.checkInId },
      {
        onSuccess: () => {
          setCheckInOutModal(true)
          setApproveCheckInModal(false)
        },
      },
    )
  }

  return (
    <div className="flex gap-20px">
      <div className="flex-1 relative mt-40px" style={{ minHeight: '35rem' }}>
        <button className="btn-prim" onClick={handleApproveCheckin}>
          {approveCheckInRequestLoading ? (
            <ButtonSpinner size={20} color="#000" />
          ) : (
            'Approve Check-in'
          )}
        </button>
      </div>
      {participantData.familyId ? (
        <div className="bg-dark-gray px-30px py-20px">
          <ParticipantAndDetails />
        </div>
      ) : null}
    </div>
  )
}

export default ApproveCheckIn
